import * as React from "react";
import LoaderButtonHybrid from "./LoaderButtonHybrid";
import type { TypeLoaderButtonProps } from "./LoaderButtonTypes";

/**
 * LoaderButton component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or a styled() extension).
 */
export const LoaderButton = (props: TypeLoaderButtonProps) => (
  <LoaderButtonHybrid {...props} />
);

export default LoaderButton;
